import Pqp from "../../../3x1010/Pqp";
import MainLoop from "../MainLoop";


export default class FramesPlayer {
  constructor(clip, anim, callback, callbackEndAnimation) {
    this.clip = clip;
    this.anim = anim;
    this.idto = -1;
    this.currentFrame = 0;
    this.frames = this.anim.frames;
    this.callback = callback;
    this.callbackEndAnimation = callbackEndAnimation;
    this.checkChangedAnimation = false;
    this.lastFrame = false;
  }

  start() {
    if (this.anim.flip) {
      this.clip.css("transform", "scaleX(-1)");
    } else {
      this.clip.css("transform", "scaleX(1)");
    }
    this.currentFrame = 0;
    this.showNextFrame();
  }
  showNextFrame() {
    let sprite = this.frames[this.currentFrame].sprite;
    let time = this.frames[this.currentFrame].time;
    this.clip.css("background-image", "url('" + sprite + "')");
    if (!Pqp.isNullOrEmpty(this.frames[this.currentFrame].goto)) {
      this.dispatch({ type: FramesPlayer.EVENT_GOTO_ANIMATION, data: { id: this.frames[this.currentFrame].goto } });
      if (this.callbackEndAnimation) {
        this.callbackEndAnimation.call(null);
      }
    } else {
      if (time !== -1) {
        this.checkChangedAnimation = true;
        this.idto = time * MainLoop.FPS_LIMIT / 1000;
      } else {
        if (this.callbackEndAnimation) {
          this.callbackEndAnimation.call(null);
        }
      }
    }
    this.currentFrame++;
    let limit = this.frames.length;
    let lGoto = false;
    if (!Pqp.isNullOrEmpty(this.frames[limit - 1].goto)) {
      lGoto = true;
      limit--;
    }

    //if (this.currentFrame === this.frames.length) {
    if (this.currentFrame === limit) {
      this.lastFrame = true;
      if (!lGoto) {
        this.currentFrame = 0;
      }
    }

  }

  dispatch(e) {
    if (this.callback) {
      this.callback.call(null, e);
    }
  }

  tick() {
    if (this.checkChangedAnimation) {
      this.idto--;
      if (this.idto <= 0) {
        if (this.lastFrame) {
          this.lastFrame = false;
          this.dispatch({ type: FramesPlayer.EVENT_END_ANIMATION });
        }
        this.checkChangedAnimation = false;
        this.showNextFrame();
      }
    }
  }

}

FramesPlayer.EVENT_GOTO_ANIMATION = "eventGotoAnimation";
FramesPlayer.EVENT_END_ANIMATION = "eventEndAnimation";